import { call } from '../actions/utils';

//**** STATION CRUD
export const createReservation = async (data, accessToken) =>
  await call({
    url: '/api/reservation/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const updateReservation = async (data, accessToken) =>
  await call({
    url: '/api/reservation/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const removeReservation = async (data, accessToken) =>
  await call({
    url: '/api/reservation/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const endReservation = async (data, accessToken) =>
  await call({
    url: '/api/reservation/end',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findAllReservations = async (data, accessToken) =>
  await call({
    url: '/api/reservation/find/all',
    data: { data },
    token: accessToken
  });
export const findReservationById = async (data, accessToken) =>
  await call({
    url: '/api/reservation/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findReservationByName = async (data, accessToken) =>
  await call({
    url: '/api/reservation/by/name',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const findReservationsByStationId = async (data, accessToken) =>
  await call({
    url: '/api/reservation/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
